import { SEASONS } from '@app/entities/enums/manage-vacations/manage-vacations.enum';

import { Proposal, SeasonCalendarEventShape } from './manage-vacations.model';

export class LogisticsVacationsProposal {
  holidays!: LogisticsProposal[];
  freeDueToPublicHolidays!: LogisticsProposal[];
  observations?: string;
  titleMessage?: string;
  isDraft!: boolean;
  maxDays!: number;

  userHasData() {
    return Boolean(this.holidays.length || this.freeDueToPublicHolidays.length || this.observations);
  }
}

export class LogisticsProposal extends Proposal {
  proposalSeason?: SEASONS;
  countableDays?: number | null;
  events?: LogisticsCalendarEvent[] | null;
}

export class LogisticsCalendarEvent {
  shape!: SeasonCalendarEventShape;
  position!: number | null;
  name!: string;
  description!: string;
  people!: LogisticsCalendarEventPeople[];
}

export interface LogisticsCalendarEventPeople {
  photo: string;
  name: string;
  description: string;
}
